const passwordRules = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$';

const PasswordRegex = RegExp(passwordRules);

export default PasswordRegex;
